import type { Message } from '../types';

export const TRANSCRIPT_BLOCK_SIZE = 320;
export const CACHED_TRANSCRIPT_DELAY_MS = 2_000;

export function getAudioTranscriptAvailability(
  message: Pick<Message, 'audioTranscriptForMemory' | 'generationStatus' | 'isUploading'>
) {
  if (typeof message.audioTranscriptForMemory === 'string' && message.audioTranscriptForMemory.trim()) {
    return 'ready';
  }
  if (message.generationStatus && message.generationStatus !== 'pending') return 'unavailable';
  if (message.isUploading || message.generationStatus === 'pending') return 'pending';
  return 'unavailable';
}

export function getTranscriptPreview(transcript: string, blocks: number) {
  // Count Unicode code points so a cut never leaves half an emoji or surrogate.
  const characters = Array.from(transcript.trim());
  const limit = Math.max(1, blocks) * TRANSCRIPT_BLOCK_SIZE;
  if (characters.length <= limit) return { text: characters.join(''), hasMore: false };
  let end = limit;
  const earliestBoundary = limit - Math.floor(TRANSCRIPT_BLOCK_SIZE * 0.2);
  // Prefer a nearby word boundary while keeping each additional block comparable.
  while (end > earliestBoundary && !/\s/u.test(characters[end])) end -= 1;
  if (end <= earliestBoundary) end = limit;
  return { text: characters.slice(0, end).join('').trimEnd(), hasMore: true };
}
